import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  Validators,
  FormGroup,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { AuthenticationService } from '../../../services/student-authentication.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  emailForm: FormGroup;
  @ViewChild(MatButton) submitButton: MatButton;
  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    private loader: AppLoaderService
  ) {}

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async onSubmit() {
    this.submitButton.disabled = true;
    if (!this.emailForm.invalid) {
      const forgotPasswordData = this.emailForm.value;
      try {
        this.loader.open('Please wait');
        await this.authenticationService.forgotPassword(
          forgotPasswordData.email
        );
        this.loader.close();
        this._snackBar.open('Password recovery email sent successfully. ', 'Close', {
          duration: 8000,
          panelClass: ['success-snackbar'],
        });
        this.userService.setUser(forgotPasswordData.email);
        this.router.navigate(['/sessions/reset-password']);
      } catch (err) {
        this.loader.close();
        this.submitButton.disabled = false;
      }
    }
  }
}
